export default "__VITE_ASSET__s347UlVS__"